import { TooltipContent } from '@/common/ui/tooltip'
import { Button } from '@/common/ui'
import { PROMOTIONS_COPY } from '@/locales/en'
import { analytics } from '../analytics/analytics'

type Props = {
    onDismiss: () => void
}

export default function TrustAccountsPromo({ onDismiss }: Props) {
    return (
        <TooltipContent
            className="mx-6 max-w-[calc(100vw-48px)] p-0 py-0 !bg-transparent !shadow-none !border-0"
            arrowClassName="fill-white"
            sideOffset={12}
        >
            <div className="w-full h-full flex justify-end items-center">
                <div className="max-w-[384px] p-6 bg-white rounded-2xl shadow-[0px_4px_16px_0px_rgba(0,0,0,0.04)] inline-flex flex-col justify-sta items-start">
                    <div className="self-stretch flex flex-col justify-start items-start gap-6">
                        <div className="self-stretch flex flex-col justify-start items-center gap-6">
                            <div className="self-stretch flex flex-col justify-start items-center gap-4">
                                <div className="self-stretch justify-start text-content-primary text-base font-semibold font-['Inter'] leading-6">
                                    {PROMOTIONS_COPY.trustAccounts.title}
                                </div>
                                <div className="self-stretch justify-start text-black text-sm font-normal font-['Inter'] leading-5">
                                    {PROMOTIONS_COPY.trustAccounts.description}
                                </div>
                                <div className="self-stretch justify-start">
                                    <span className="text-black text-sm font-normal font-['Inter'] leading-5">
                                        {PROMOTIONS_COPY.trustAccounts.ctaPrefix}
                                    </span>
                                    <span className="text-black text-sm font-semibold font-['Inter'] leading-5">
                                        {PROMOTIONS_COPY.trustAccounts.ctaAction}
                                    </span>
                                    <span className="text-black text-sm font-normal font-['Inter'] leading-5">
                                        {PROMOTIONS_COPY.trustAccounts.ctaSuffix}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pt-6 flex flex-col justify-start items-start gap-2.5">
                        <Button
                            variant={'secondary'}
                            onClick={() => {
                                analytics.trackWithDefaults('trust_accounts_promo_dismissed')
                                onDismiss()
                            }}
                        >
                            {PROMOTIONS_COPY.trustAccounts.gotIt}
                        </Button>
                    </div>
                </div>
            </div>
        </TooltipContent>
    )
}
